// Lets us try alternate fonts on localhost only, via a URL parameter instead
// of editing code every time. Production always ships Inter alone.
export const FONT_QUERY_PARAM = 'font';
export const FONT_COOKIE = 'font_experiment';

export type FontExperimentId =
  | 'roboto'
  | 'manrope'
  | 'jakarta'
  | 'nunito'
  | 'inter'
  | 'poppins'
  | 'sora'
  | 'outfit';

export const DEFAULT_FONT: FontExperimentId = 'inter';

const VALID_IDS: FontExperimentId[] = ['roboto', 'manrope', 'jakarta', 'nunito', 'inter', 'poppins', 'sora', 'outfit'];

function isFontExperimentId(value: string | null | undefined): value is FontExperimentId {
  return !!value && (VALID_IDS as string[]).includes(value);
}

// Browser-only (matches readLayoutVersionFromBrowser) - always returns the
// default during SSR/static generation.
export function readFontExperimentFromBrowser(): FontExperimentId {
  if (typeof window === 'undefined') return DEFAULT_FONT;

  const fromQuery = new URLSearchParams(window.location.search).get(FONT_QUERY_PARAM);
  if (isFontExperimentId(fromQuery)) {
    document.cookie = `${FONT_COOKIE}=${fromQuery}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
    return fromQuery;
  }

  const match = document.cookie.match(new RegExp(`(?:^|; )${FONT_COOKIE}=([^;]+)`));
  const fromCookie = match?.[1];
  if (isFontExperimentId(fromCookie)) return fromCookie;

  return DEFAULT_FONT;
}
